import React from 'react';
import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';

class OnlineIndicator extends React.Component {
	render() {
		const player = this.props.player;
		const isOnline = player.isOnline();
		const status = player.getStatus();
		const classes = new JqueryClassFaker();
		classes.push('indicator fa');
		let title = null;
		// .is_offline{
		// .idle_indicator, .away_indicator{
		// .active_indicator
		if(isOnline) {
			title = 'Is Online';
			classes.push('active_indicator');
		}
		else if(!isOnline) {
			title = 'Is Offline';
			classes.push('is_offline');
		}
		if(player.active_match_id) {
			title = 'Playing a Match';
			classes.push('fa-gamepad');
		}
		else if(player.isSearching()) {
			title = 'Searching for a Match';
			classes.push('fa-search');
		}
		else if(isOnline) {
			classes.push('fa-circle');
		}
		else {
			classes.push('fa-circle');
		}

		return (
			<OnlineIndicatorElement
				title={title}
				className={classes.toString()}
			/>
		);
	}
}

class OnlineIndicatorElement extends React.PureComponent {
	render() {
		const { title, className } = this.props;
		return (
			<span className='online_indicator' title={title}><i className={className} /></span>
		);
	}
}

export { OnlineIndicator, OnlineIndicatorElement };